<template>
  <div class="header" v-bind:style="{height: height/100+'rem'}">
    <slot></slot>
  </div>
</template>
<script>
  export default {
  	name: "appHeader",
    props: {
  		height: {
  			type: Number
      }
    }
  }
</script>
<style lang="scss" scoped>
  .header{
    height: 1rem;
    position: relative;
    z-index: 1;
    color: green;
  }
</style>


// WEBPACK FOOTER //
// src/layouts/AppHeader/index.vue